export const miscConstants = {
    baseUrl: "/react-store-typescript"
}